import * as React from 'react';
import withStyles from 'react-jss';
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Tooltip from 'antd/lib/tooltip';
import Icon from 'antd/lib/icon';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Form, { FormComponentProps } from 'antd/lib/form';
import message from 'antd/lib/message';
import Checkbox from 'antd/lib/checkbox';
import Spin from 'antd/lib/spin';
import classNames from 'classnames';
import { connect } from 'react-redux';
import TransitShipIcon from 'src/components/common/icons/TransitShipIcon';
import moment from 'moment';
import { discoverRatesReportIssue, createBookingData } from 'src/api/discoverRates';
import {
  SearchResult,
  Charge,
  FetchedInquiries,
  SearchParams,
} from './TypesInDiscoverRates/SearchResult';
import { formatNumberWithCommas, arrayToObject , isDemoOrganisation } from 'src/utils/utils';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import { isValidArray, isValidString, formatPriceAfterMillion, clone } from 'src/Library/Helper';
import { isSellRatesContentVisible, LINKING_STATUS, getGAEventCategory, modeSpecificChargeNameMap, chargeListUnitTypeMap, modeSpecificChargeDisplayNameMap, modeWiseUnit } from './DiscoverRateUtils';
import { ChargeListCardsStyles } from './ChargeListCards.styles';
import { tokens } from 'src/design-system';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';
import { SelectedFilters } from './TypesInDiscoverRates/SelectedFilters';
import { fetchPreviousInquiries, fetchInquiryDetailsForShipper } from 'src/api/inquiry';
import InquiryConfirmationModal from './InquiryConfirmationModal';
import CreateInquiryModal from '../Enquiry/Modals/CreateInquiryModal';
import BookingSuccessProtip from '../Enquiry/Modals/BookingSuccessProtip';
import { bookingShipperRoute } from 'src/routing/utils';
import { fetchKYC } from '../kycConnections/kycConnections.api';
import { KYCData } from '../kycConnections/KycConnections.types';
import FFConnectionRequestKYC from '../kycConnections/FFConnectionRequestKYC';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { InquiryModes, PERMISSON_ERROR_MESSAGE, UserRole } from 'src/Library/Constants';
import BookingTnCModal from './BookingTnCModal';
import { Carrier } from 'src/Library/Types';
import { nl2Br } from 'src/utils/DOMUtils';
import ShareRateModal from './ShareRateModal';
import InformReason from '../Enquiry/Modals/InformReason';
import AirModeIcon from 'src/components/common/icons/AirModeIcon';
import AdditionalEmailsForBookingModal from '../Enquiry/Modals/AdditionalEmailsForBookingModal';
import { weekDayMap } from '../RateMaster/RateMasterUtils';
import DomesticTruckIcon from 'src/components/common/icons/DomesticTruckIcon';
import TrailerModeIconBlack from 'src/components/common/icons/TrailerModeIconBlack';
import FieldRate from 'src/components/common/form/FieldRate';

interface ChargeListCardsProps extends FormComponentProps {
  classes: {
    [X in keyof ReturnType<typeof ChargeListCardsStyles>]: string;
  };
  data: SearchResult;
  topResult: SearchResult;
  searchFilters: SearchFilters;
  isItemPresent: {
    isLocalsPresent: boolean;
    activeKey: string;
    ffListMap: Record<string, { id: string; name: string; linkingStatus: LINKING_STATUS }>;
    handleNewInquiry: (disableFields?: boolean) => void;
    history: any;
  };
  buyRatesViewPermission: boolean;
  ffName: string;
  orgType: string;
  getAllDataSetFilter: (val: Partial<SelectedFilters>, apiCall?: boolean) => void;
  selectedFilters: SelectedFilters;
  createInquiryPermission: boolean;
  shippingLines: Carrier[];
  uuid: string;
  isShareModule: boolean;
  userRole: UserRole;
  showMarkupCriteria: boolean;
  businessTypeList: any[];
  vendorRating?: string[];
}

interface StateProps {
  isChargeBreakdownVisible: boolean;
  viewInformReason: boolean;
  remark: string;
  isReportModalVisible: boolean;
  isLoading: boolean;
  isReported: boolean;
  imgDimensions: {
    height: number;
    width: number;
  };
  isInquiryConfirmationVisible: boolean;
  inquiryData: FetchedInquiries[];
  fetchingCustomisedRates: boolean;
  searchParams?: SearchParams;
  isCreateInquiryModalVisible: boolean;
  bookingId: string;
  bookingNumber: string;
  protipVisible: boolean;
  inquiryDataResponse: any;
  isGeneratingBookingData: boolean;
  isFFSelectionModalVisible: boolean;
  isFFConnectionRequestVisible: boolean;
  kycData: KYCData[];
  kycExists: boolean;
  isBookingTnCModalVisible: boolean;
  weightSlabsDetails: {min: number, max: number}[] | null;
  isAdditionalEmailsModalVisible?: boolean;
}

const { useState, useEffect } = React;
const { FCL, LCL, AIRCARGO, DOMESTIC, TRAILER, RPTL } = InquiryModes;
const ChargeListCards = (props: ChargeListCardsProps): React.ReactElement => {
  const {
    classes,
    data,
    topResult,
    form,
    searchFilters,
    isItemPresent,
    buyRatesViewPermission,
    orgType,
    getAllDataSetFilter,
    selectedFilters,
    createInquiryPermission,
    shippingLines,
    uuid,
    isShareModule,
    ffName,
    showMarkupCriteria,
    businessTypeList,
  } = props;

  const { isLocalsPresent, activeKey, ffListMap, handleNewInquiry, history } = isItemPresent;
  const { incoterm, movementType, shipperTeamId, mode = FCL, grossWeight, totalVolume, totalVolumetricWeight } = searchFilters;
  const { originServices, destinationServices } = selectedFilters;

  const [state, setState] = useState<StateProps>({
    isChargeBreakdownVisible: !!isShareModule,
    isReportModalVisible: false,
    isLoading: false,
    isReported: false,
    imgDimensions: {
      height: 0,
      width: 0,
    },
    isInquiryConfirmationVisible: false,
    inquiryData: [],
    fetchingCustomisedRates: false,
    searchParams: undefined,
    isCreateInquiryModalVisible: false,
    bookingId: '',
    bookingNumber: '',
    protipVisible: false,
    inquiryDataResponse: {},
    isGeneratingBookingData: false,
    isFFSelectionModalVisible: false,
    isFFConnectionRequestVisible: false,
    kycData: [],
    kycExists: false,
    isBookingTnCModalVisible: false,
    viewInformReason: false,
    remark: '',
    weightSlabsDetails: null
  });

  const [shareModalVisible, setShareModalVisible] = useState(false);

  const {
    isChargeBreakdownVisible,
    isReportModalVisible,
    isLoading,
    isReported,
    imgDimensions,
    isInquiryConfirmationVisible,
    inquiryData,
    fetchingCustomisedRates,
    searchParams,
    isCreateInquiryModalVisible,
    bookingId,
    bookingNumber,
    protipVisible,
    inquiryDataResponse,
    isGeneratingBookingData,
    isFFSelectionModalVisible,
    isFFConnectionRequestVisible,
    kycData,
    kycExists,
    isBookingTnCModalVisible,
    viewInformReason,
    remark,
    weightSlabsDetails,
    isAdditionalEmailsModalVisible,
  } = state;

  const total = data.totalPrice || data.totalFreight;
  const isModeTypeRoadDomestic = mode === DOMESTIC;
  const isModeTypeTrailer = mode === TRAILER;
  const isModeTypeRPTL = mode === RPTL;
  const setStateUtil = (newState: Partial<StateProps>) => {
    setState((oldState: StateProps) => {
      return {
        ...oldState,
        ...newState,
      };
    });
  };

  useEffect(() => {
    getImgHeightWidth();
  }, []);

  useEffect(() => {
    if (!(isCreateInquiryModalVisible || isFFConnectionRequestVisible || protipVisible || viewInformReason || shareModalVisible || isAdditionalEmailsModalVisible || isInquiryConfirmationVisible || isReportModalVisible)) return;
    const scrollY = window.scrollY;
    const originalCssText = document.body.style.cssText;
    document.body.style.cssText = `${originalCssText} position: fixed; top: -${scrollY}px; width: 100%; overflow: hidden;`;
    return () => { document.body.style.cssText = originalCssText; window.scrollTo(0, scrollY); };
  }, [isCreateInquiryModalVisible, isFFConnectionRequestVisible, protipVisible, viewInformReason, shareModalVisible, isAdditionalEmailsModalVisible, isInquiryConfirmationVisible, isReportModalVisible]);

  const getImgHeightWidth = () => {
    const img = new Image();
    const logoUrl = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? (data.ffOrganisation?.logoUrl || data.carrier.logoUrl) : data.carrier.logoUrl;
    img.src = logoUrl;
    const maxWidth = 100;
    const maxHeight = 40;
    img.onload = () => {
      const imgHeight = img.naturalHeight || img.height;
      const imgWidth = img.naturalWidth || img.width;
      const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
      const width = imgWidth * ratio;
      const height = imgHeight * ratio;
      setStateUtil({ imgDimensions: { width, height } });
    };
  };

  const renderCarrierInfo = (): React.ReactElement => {
    const org = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.ffOrganisation : data?.carrier;
    return (
      <Col span={6} className={classes.carrierInfo}>
        <span style={{ width: '100px', marginRight: '18px', minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
          <img
            src={org?.logoUrl}
            className={classes.carrierLogo}
            style={{ ...imgDimensions }}
            alt={'Org Logo'}
          />
        </span>
        <Tooltip title={data.carrier?.name}>
          <span className={classes.carrierCode}>{org?.name??''}</span>
        </Tooltip>
      </Col>
    );
  };

  const renderPreferredWetPort = (port, preferredWetPort): React.ReactElement => {
    return (
      <div className={classes.wetPort}>
        <span style={{ color: '#666666', fontWeight: 'normal' }}>{port}: </span>
        <Tooltip
          title={`${port}: ${preferredWetPort.name}`}
          overlayClassName={classes.tooltipStyle}
        >
          {preferredWetPort.name}
        </Tooltip>
      </div>
    );
  };

  const renderPort = (port, title): React.ReactElement => {
    if (!port) {
      return (
        <div style={{ margin: '0px 15px' }}>
          <div className={classes.routeInfo}>
            <span className={classes.portDetail}>-</span>
          </div>
        </div>
      );
    }
    const preferredWetPort =
      title === 'POL' ? data.preferredOriginWetPort : data.preferredDestinationWetPort;
    const isPort = port?.type;
    const isCityMode = isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL;
    const displayText = isCityMode 
      ? (port?.city || port?.name || (port?.displayAddress ? port.displayAddress.split(',')[0] : null) || port?.code || '-')
      : (!isPort ? (port?.city || port?.name) : port?.code);
    const stateText = isCityMode ? port?.state?.trim() || null : null;
    return (
      <div style={{ margin: '0px 15px' }}>
        <div className={classes.routeInfo}>
          <img src={port?.flagS3Link} style={{ maxWidth: '25px' }} />
          <div>
            <span className={classes.portDetail}>{displayText || '-'}</span>
            {stateText && <div className={classes.portState}>{stateText}</div>}
          </div>
        </div>
        {preferredWetPort && renderPreferredWetPort(title, preferredWetPort)}
      </div>
    );
  };

  const renderLine = (): React.ReactElement => {
    return <div className={classes.line} />;
  };

  const renderDot = (styles): React.ReactElement => {
    return <div className={classes.dot} style={{ ...styles }} />;
  };

  const renderLineAndDots = (): React.ReactElement => {
    return (
      <span className={classes.lineAndDot}>
        {renderDot('')}
        {renderLine()}
        {data.transshipments?.length ? (
            <React.Fragment>
              {renderDot({
                backgroundColor: '#333333',
                height: '4px',
                width: '4px',
              })}
              {renderLine()}
            </React.Fragment>
          ) : null}
        {renderDot('')}
      </span>
    );
  };

  const getTransitIcon = (mode: InquiryModes) => {
    switch (mode) {
      case AIRCARGO:
        return <AirModeIcon />;
      case DOMESTIC: 
        return <DomesticTruckIcon strokeColor={'#000'} fill={'#000'} />
      case TRAILER: 
        return <TrailerModeIconBlack fill={'#666'}/>
      case RPTL:
        return <DomesticTruckIcon strokeColor={'#000'} fill={'#000'} />
      default:
        return <TransitShipIcon />;
    }
  }

  const renderRoute = (): React.ReactElement => {
    return (
      <div className={classes.route} style={{width: (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? '45%' : '30%'}}>
        {data.isDirect === null ? (
          <Tooltip
            title={'Route: Not Available'}
            mouseEnterDelay={0.5}
            overlayClassName={classes.tooltipStyle}
          >
            <span style={{ color: '#CCCCCC', fontSize: '9px', visibility: (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? 'hidden' : 'initial' }}>Not Available</span>
          </Tooltip>
        ) : (
          <div style={{ fontSize: '10px' }}>
            {!data.isDirect && data.transshipments?.length ? (
              <React.Fragment>
                <Tooltip
                  title={
                    <React.Fragment>
                      <span style={{ fontSize: '11px', backgroundColor: '#000000' }}>
                        Transshipment
                      </span>
                      <ul className={classes.transshipmentList}>
                        {data.transshipments?.length &&
                          data.transshipments.map((item) => (
                            <li>{`${item.name} (${item.code})`}</li>
                          ))}
                      </ul>
                    </React.Fragment>
                  }
                  overlayClassName={classes.tooltipStyle}
                  mouseEnterDelay={0.5}
                >
                  {data.transshipments[0]?.code}
                  {data.transshipments.length > 1 && ` + ${data.transshipments.length - 1}`}
                </Tooltip>
              </React.Fragment>
            ) : (
              <Tooltip
                title={'Route: Direct'}
                mouseEnterDelay={0.5}
                overlayClassName={classes.tooltipStyle}
              >
                Direct
              </Tooltip>
            )}
          </div>
        )}
        {renderLineAndDots()}
        <div className={classes.transitDays}>
          {getTransitIcon(mode)}
          &nbsp;
          {data.transitDays || data.transitDays === 0 ? (
            <Tooltip
              title={`Transit Days: ${data.transitDays}`}
              mouseEnterDelay={0.5}
              overlayClassName={classes.tooltipStyle}
            >
              <span style={{marginBottom: isModeTypeTrailer ? '-5px' : 'unset'}}>
                {data.transitDays} {isModeTypeTrailer ? 'Hour' : 'Day'}{data?.transitDays > 1 ? 's' : ''}
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              title="Transit Days: Not Available"
              mouseEnterDelay={0.5}
              overlayClassName={classes.tooltipStyle}
            >
              <span style={{ color: '#CCCCCC', fontSize: '9px' }}>Not Available</span>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  const isShipperWithCreateInquiryPermission = () => {
    return orgType === 'SHIPPER' && createInquiryPermission && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL);
  };

  const isLocalsOrMarginVisible = () => {
    return (
      isLocalsPresent ||
      isSellRatesContentVisible(buyRatesViewPermission, activeKey) ||
      isShipperWithCreateInquiryPermission()
    );
  };

  const renderRouteInfo = (): React.ReactElement => {
    const pol = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.origin : data?.pol;
    const pod = (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.destination : data?.pod;
    return (
      <Col
        span={(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? 14 : isLocalsOrMarginVisible() ? 9 : 11}
        className={classNames(classes.flexDiv, classes.border)}
      >
        {renderPort(pol, 'POL')}
        {renderRoute()}
        {renderPort(pod, 'POD')}
      </Col>
    );
  };

  const renderChargeFontSize = (charge): string => {
    if (charge >= 1.0e4 && charge < 1.0e6 || isLocalsPresent) {
      return '15px';
    }
    return '18px';
  };

  const renderChargeFontWeight = (charge) => {
    if (charge >= 1.0e4 && charge < 1.0e6) {
      return 600;
    }
    return 'bold';
  };

  const getColSpanForChargeInfo = (title) => {
    if (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) return 24;
    if (
      (isSellRatesContentVisible(buyRatesViewPermission, activeKey) || isShipperWithCreateInquiryPermission()) &&
      title !== 'Total' &&
      isLocalsPresent 
    ) {
      return 7;
    } else if (isLocalsOrMarginVisible() || isShipperWithCreateInquiryPermission()) return 8;
    return 12;
  };

  const renderChargeInfo = (charge, title): React.ReactElement => {
    const chargeAmount = charge?.amount != null && typeof charge.amount === 'number' ? charge.amount : (charge?.amount ? parseFloat(charge.amount) : 0);
    const formattedPriceAfterMillion = formatPriceAfterMillion(chargeAmount?.toFixed(2));
    const formattedPriceWithCommas = formatNumberWithCommas(formattedPriceAfterMillion);
    return (
      <Col span={getColSpanForChargeInfo(title)} style={{ paddingRight: '8px' }}>
        <div className={classes.chargeDiv}>
          {charge ? (
            <span
              className={title === 'Total' ? classes.totalCharge : classes.otherCharges}
              style={
                title === 'Total'
                  ? undefined
                  : {
                    fontSize: renderChargeFontSize(chargeAmount),
                    fontWeight: renderChargeFontWeight(chargeAmount),
                  }
              }
            >
              <span className={classes.currency}>{charge?.currency}</span>
              {formattedPriceWithCommas}
            </span>
          ) : (
            <div style={{ color: '#CCCCCC', fontSize: '11px', lineHeight: '30px' }}>
              Not Available
            </div>
          )}
          <span style={{ fontSize: '10px', fontWeight: 'normal' }}>{title}</span>
        </div>
      </Col>
    );
  };

  const getMarginStyles = (amount) => {
    const marginAmount = amount ? Number(amount.toFixed(2)) : amount;
    if (marginAmount >= 0) {
      return classes.marginPositive;
    } else if (marginAmount < 0) {
      return classes.marginNegative;
    } else {
      return classes.noMargin;
    }
  };

  const renderMarginAmount = (amount, type, negative = false, showPlus = false) => {
    return (
      <React.Fragment>
        {type === 'USD' && (
          <React.Fragment>
            <span>{negative ? '-' : showPlus ? '+' : ''} &nbsp;</span>
            <span>USD </span>
          </React.Fragment>
        )}
        {amount}
        <span style={{ fontSize: '8px' }}>{type === 'Percentage' && '%'}</span>
      </React.Fragment>
    );
  };

  const renderAmount = (amount, type, negative = false, showPlus = false) => {
    const marginAmount = amount ? Number(amount.toFixed(2)) : 0;
    if (marginAmount >= 0) return renderMarginAmount(marginAmount, type, false, showPlus);
    else if (marginAmount < 0) return renderMarginAmount(Math.abs(marginAmount), type, negative);
    return renderMarginAmount(0, type, negative, showPlus);
  };

  const renderMargin = () => {
    const amount = data?.markup?.perContainerMarkupAmount;
    return (
      data?.markup && (
        <div
          className={classNames(
            classes.margin,
            getMarginStyles(amount),
            isLocalsPresent && classes.marginDivPosition
          )}
        >
          <div style={{ fontSize: '12px', fontWeight: 600 }}>
            {renderAmount(amount, 'USD', true, false)}
          </div>
          <div style={{ fontSize: '10px' }}>Margin/{modeWiseUnit[mode]}</div>
        </div>
      )
    );
  };

  const getChargeColSpan = () => {
    if (isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) return 4
    if (
      (isSellRatesContentVisible(buyRatesViewPermission, activeKey) || isShipperWithCreateInquiryPermission()) &&
      isLocalsPresent
    )
      return 8;
    else if (
      isLocalsPresent ||
      isSellRatesContentVisible(buyRatesViewPermission, activeKey) ||
      isShipperWithCreateInquiryPermission()
    )
      return 9;
    return 7;
  };

  const getPortDataForBooking = (portType) => {
    return {
      port: portType.code,
      countryCode: portType.countryCode || portType.country_code,
      countryName: portType.countryName || portType.country_name,
    };
  };

  const getBookingData = () => {
    const { container, cargo, incoterm, movementType, mode, grossWeight,
      totalVolume, count = 1, length, breadth, height, dimensionUnit, totalVolumetricWeight } = searchFilters;
    const { noOfContainers, originServices, destinationServices } = selectedFilters;

    const searchUUID = localStorage.getItem('searchUUID');
    const containerDetails = JSON.parse(container || '[]')?.key;
    const {
      ffOrganisation,
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
      pol,
      pod,
      productList,
      containerWeight,
      customerId,
      stakeholderId,
      termsAndConditions,
      stuffingLocations,
      destuffingLocations,
      internalReferenceNumber,
      requiredOriginFreeDays,
      requiredDestinationFreeDays,
    } = data;
    return {
      requiredOriginFreeDays,
      requiredDestinationFreeDays,
      customerId,
      stakeholderId,
      termsAndConditions,
      internalReferenceNumber,
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
      searchUUID,
      mode,
      origin: getPortDataForBooking(pol),
      destination: getPortDataForBooking(pod),
      container: {
        ...(containerDetails && containerDetails),
        ...(containerWeight && { weight: containerWeight }),
        count: count || noOfContainers,
        ...(length && {
          packageDimension: {
            height,
            breadth,
            length,
            unit: dimensionUnit,
          }
        }),
        ...(grossWeight && { weight: grossWeight }),
        ...(totalVolume && { volume: {...totalVolume, value: totalVolume.value / count}  }),
        ...(totalVolumetricWeight && { volumetricWeight: {...totalVolumetricWeight, value: totalVolumetricWeight.value / count}  })
      },
      cargo: {
        ...JSON.parse(cargo || '[]')?.key,
      },
      ffOrganisationId: ffOrganisation?.id,
      linkingStatus: ffListMap[data?.ffOrganisation?.id]?.linkingStatus,
      incoterm: incoterm || data?.incoterm, 
      movementType: movementType || data?.movementType,
      originServices: originServices && originServices?.length > 0 ? originServices : data?.originServices, 
      destinationServices: destinationServices && destinationServices?.length > 0 ? destinationServices : data?.destinationServices,
      stuffingLocations,
      destuffingLocations,
      ...(Array.isArray(productList) && productList.length > 0 && 
            productList.some(product => product?.id) && { 
          productList: productList.map(product => ({
            key: product.id,
            name: product.internalName,
            quantity: product.count,
            unit: product.unit,
            referenceNumber: product.referenceNumber,
            productCnSize: product.productCnSize,
            productCnType: product.productCnType,

          }))
      })
    };
  };

  const createBooking = async () => {
    setStateUtil({ isGeneratingBookingData: true });
    const body = getBookingData();
    const response = await createBookingData(body);
    if (!response.isSuccess) {
      message.error(response.errorMessage);
      setStateUtil({ isGeneratingBookingData: false });
    } else {
      setStateUtil({
        isCreateInquiryModalVisible: true,
        inquiryDataResponse: { 
          ...response.data, 
          internalReferenceNumber: body.internalReferenceNumber,
          requiredOriginFreeDays: body.requiredOriginFreeDays,
          requiredDestinationFreeDays: body.requiredDestinationFreeDays,
        },
        isGeneratingBookingData: false,
      });
    }
  };

  const handleBookNow = async () => {
    if (isDemoOrganisation()) {
      message.error(PERMISSON_ERROR_MESSAGE);
      return;
    }
    sendEvent(EventCategories.DISCOVER_RATES_BOOKING_SHIPPER, 'Discover rates Book - clicked');
    if (ffListMap[data?.ffOrganisation?.id]?.linkingStatus === LINKING_STATUS.NON_LINKED) {
      setStateUtil({ isGeneratingBookingData: true });
      const response = await fetchKYC();
      if (!response.isSuccess) {
        message.error(response.errorMessage);
        setStateUtil({ isGeneratingBookingData: false });
      } else {
        setStateUtil({
          isFFSelectionModalVisible: false,
          isFFConnectionRequestVisible: true,
          kycData: response.data?.kycData,
          kycExists: response.data?.kycExists,
          isGeneratingBookingData: false,
        });
      }
    } else {
      createBooking();
    }
  };

  const handleTnc = (): void => {
    data.rank === topResult?.rank ? handleBookNow() : openInformReason();
    // setStateUtil({
    //   isBookingTnCModalVisible: true,
    // });
  };

  const renderChargeInfoDiv = (): React.ReactElement => {
    const { isBulkNegotiationOn } = selectedFilters;
    const { mode = FCL,} = searchFilters; 
    const isExpired = data?.validityEnd && moment(data.validityEnd) < moment();
    return (
      <Col span={getChargeColSpan()} className={classes.charges}>
        {isLocalsPresent && !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? (
          <React.Fragment>
            {renderChargeInfo(data?.totalFreight, 'Freight')}
            {renderChargeInfo(data?.totalLocalCharge, 'Locals')}
            {renderChargeInfo(total, 'Total')}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {!(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && renderChargeInfo(data?.oceanFreight, modeSpecificChargeDisplayNameMap[mode]?.freight)}
            {renderChargeInfo(total, 'Total Freight')}
          </React.Fragment>
        )}
        {isShipperWithCreateInquiryPermission() && data?.ffOrganisation && !isExpired && (
          <div
            className={classes.negotiateDiv}
            style={{
              right: isLocalsPresent ? '-11%' : '8px',
            }}
          >
            <Button
              onClick={() => handleTnc()}
              style={{ opacity: isBulkNegotiationOn ? 0.8 : 1 }}
              disabled={isBulkNegotiationOn}
              className={classes.bookNowButton}
              loading={isGeneratingBookingData}
            >
              Book
            </Button>
            {/* <div  //commented to remove single negotiation action
              className={classes.negotiate}
              style={{ opacity: isBulkNegotiationOn ? 0.3 : 1 }}
              onClick={() => {
                if (!isBulkNegotiationOn) {
                  sendEvent(
                    EventCategories.DISCOVER_RATES_NEGOTIATE_SHIPPER,
                    'Negotiate on single rate - clicked'
                  );
                  handleNegotiateRates();
                }
              }}
            >
              Negotiate
              {fetchingCustomisedRates && <Spin size="small" style={{ marginLeft: '4px' }} />}
            </div> */}
          </div>
        )}
      </Col>
    );
  };

  const renderWeightSlabAvailable = (): React.ReactElement => {
    const isWeightSlabAvailable = Object.keys(data?.chargeBreakdown).some((key) =>
      data?.chargeBreakdown[key].some((item) => item.isWeightSlabAvailable)
    );
    return (
      isWeightSlabAvailable ? (
        <Col span={11} style={{ fontWeight: 600 }}>
          <React.Fragment>
            <Col span={1} style={{ marginRight: '5px' }}>
              <Icon
                type="exclamation-circle"
                theme="filled"
                style={{ fontSize: '12px', color: tokens.colors.textSecondary }}
              />
            </Col>
            <Col span={22}>
              Different rates subject to weight are available for this Shipping line.
              <br />
              To know the best relevant rate, &nbsp;
              <span style={{ color: tokens.colors.primaryDark, textDecoration: 'underline' }}>
                ADD WEIGHT DETAILS
              </span>
            </Col>
          </React.Fragment>
        </Col>
      ) : (
        <Col span={6} style={{ fontWeight: 600 }}>
          </Col>
      )
    );
};

  const renderWeightSlab = (): React.ReactElement | null => {
    let { weightSlabsDetails } = state;
    if (!weightSlabsDetails){
      Object.keys(data?.chargeBreakdown).forEach((key) => {
        data.chargeBreakdown[key].forEach((item) => {
          if (item.isWeightSlabAvailable){ 
            weightSlabsDetails = item.weightSlab;
            setStateUtil({ weightSlabsDetails });
            return;
          }
        })
        if (weightSlabsDetails) return;
      });
    }
    if (!weightSlabsDetails) return null;
    const [{ min, max }] = weightSlabsDetails;
    return (
      <Col span={5}>
        <span style={{ fontWeight: 600 }}>
          Weight Slab: {`(${min} - ${max}) mt`}
        </span>
      </Col>
    );
  };

  const handleViewDetailsClick = (): void => {
    if (isShareModule) return;
    setStateUtil({ isChargeBreakdownVisible: !isChargeBreakdownVisible });
  };
   const renderFreeDaysOnCard =( ) => {
    return (
      <Row
      className={classes.bottomCard}
        style={{ paddingLeft: 0 }}
        >
 {(data?.detentionFreeDays || data?.detentionFreeDays === 0) && (
              <Col span={5} style={{ color: '#666666' }}>
                Detention Free Days:{' '}
                <span style={{ fontWeight: 600 }}>{data?.detentionFreeDays + (
                  data?.detentionFreeDaysRemarks ? ` ${data?.detentionFreeDaysRemarks}` : ''
                )}</span>
              </Col>
            )}
          {(data?.demurrageFreeDays || data?.demurrageFreeDays === 0) && (
              <Col span={5} style={{ color: '#666666' }}>
                Demurrage Free Days:{' '}
                <span style={{ fontWeight: 600 }}>{data?.demurrageFreeDays + (
                  data?.demurrageFreeDaysRemarks ? ` ${data?.demurrageFreeDaysRemarks}` : ''
                )}</span>
              </Col>
            )}
          {(data?.freeDaysOrigin || data?.freeDaysOrigin === 0) && (
              <Col span={5} style={{ color: '#666666' }}>
                Origin Free Days :{' '}
                <span style={{ fontWeight: 600 }}>{data?.freeDaysOrigin + (
                  data?.originFreeDaysRemarks ? ` ${data?.originFreeDaysRemarks}` : ''
                )}</span>
              </Col>
            )}
          {(data?.cfsFreeDays || data?.cfsFreeDays === 0) && (
              <Col span={5} style={{ color: '#666666' }}>
                CFS Free Days :{''}
                <span style={{ fontWeight: 600 }}>{data?.cfsFreeDays + (
                  data?.cfsFreeDaysRemarks ? ` ${data?.cfsFreeDaysRemarks}` : ''
                )}</span>
              </Col>
            )}
          {(data?.combinedFreeDays || data?.combinedFreeDays === 0) && (
              <Col span={5} style={{ color: '#666666' }}>
                Combined Free Days :{' '}
                <span style={{ fontWeight: 600 }}> {data?.combinedFreeDays + (
                  data?.combinedFreeDaysRemarks ? ` ${data?.combinedFreeDaysRemarks}` : ''
                )}</span>
              </Col>
            )}
        </Row>
    )
   }
  const getViewDetailsColSpan = () => {
    const isShipper = orgType === 'SHIPPER';
    const colSpan = isShipper && data.source ? 6 : 8;
    if (isShipper){
      return weightSlabsDetails ? 4 : colSpan
    }
    return data.shipperOrganisation ? 8 : 5;
  }

  const renderBottomCardDiv = (): React.ReactElement => {
    const {vendorRating} = props;
    const validity = `${(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? '' : 'Freight'} Validity - ${moment(data.validityEnd).format('DD MMM YYYY')}`;
    const orgName = data.shipperOrganisation?.name || data.ffOrganisation?.name;
    const isShipper = orgType === 'SHIPPER';
    const rating = data.ffOrganisation?.rating;
    const colSpan = isShipper && data.source ? (rating ? 5 : 6) : 8;
    return (
      <Row
        className={classes.bottomCard}
        style={{ paddingLeft: 0 }}
        onClick={handleViewDetailsClick}
      >
        <Col span={colSpan}>
          <span style={{ fontWeight: 600, display: 'flex' }}>
            {(data.shipperOrganisation || data.ffOrganisation) &&
            !(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? (
              <Tooltip
                title={orgName}
                placement="topLeft"
                mouseEnterDelay={0.5}
                overlayStyle={{ fontSize: '10px' }}
              >
                <span
                  style={{ backgroundColor: getRateTypeColor(true) }}
                  className={classes.shipperOrg}
                >
                  <span>
                    {orgType !== 'SHIPPER' && (data.type === 'BUY' ? 'Buy Rate' : 'FAK Price')}
                    {orgType !== 'SHIPPER' && ' | '}
                    {orgType === 'SHIPPER' && ' FF - '}
                    {orgName}
                  </span>
                </span>
              </Tooltip>
            ) : (
              <span style={{ marginLeft: '32px', fontWeight: 600 }}>{validity}</span>
            )}
          </span>
        </Col>
        {orgType === 'SHIPPER' && rating && vendorRating?.length ? (
          <Col span={colSpan} style={{display: 'flex'}}>
            <Tooltip title={rating ? vendorRating[rating -  1] : ''}>Vendor Rating &nbsp;</Tooltip>
            <FieldRate
              isView={true}
              isFlex={true}
              styles={{ fontSize: '10px' }}
              disabled={true}
              value={rating}
            />
          </Col>
        ) : null}
        {orgType === 'SHIPPER' && data.source && (
          <Col span={weightSlabsDetails ? 4 : rating ? 4 :colSpan}>
            {!(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? (
              <span style={{ fontWeight: 600 }}>
                Source: {data.source === 'SPOT' ? 'CONTRACT' : data.source}
              </span>
            ) : (
              ''
            )}
          </Col>
        )}
        {renderWeightSlab()}
        {data.shipperOrganisation || data.ffOrganisation ? (
          <Col span={weightSlabsDetails ? 5 : rating ? 4 :colSpan}>
            {isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL ? '' : validity}
          </Col>
        ) : (
         renderWeightSlabAvailable()
        )}
        {!isShareModule && (
          <Col
            span={getViewDetailsColSpan()}
            className={classes.viewHideDetails}
            style={{ textAlign: 'right' }}
          >
            {isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL ? (
              ''
            ) : (
              <span onClick={handleShareRateModal}>
                <Icon type="share-alt" /> Share Rates &nbsp;|&nbsp;
              </span>
            )}
            {isChargeBreakdownVisible ? 'Hide Details' : 'View Details'}
          </Col>
        )}
      </Row>
    );
  };

  const renderChargeTitle = (key: string): string => {
    switch (key) {
      case 'freightCharges':
        return 'Freight Charges';
      case 'originCharges':
        return 'Origin Charges';
      case 'destinationCharges':
        return 'Destination Charges';
      default:
        return key;
    }
  };

  const renderColumn = (charge, index, color) => {
    const totalMarkupAmount = data?.markup?.totalMarkupAmount?.toFixed(2)
      ? Number(data.markup?.totalMarkupAmount?.toFixed(2))
      : 0;
    const showMarginBreakdown =
      charge?.name === modeSpecificChargeNameMap?.[mode || FCL]?.freight &&
      data?.oceanFreight?.baseAmount &&
      !isShareModule;
    return (
      <React.Fragment>
        <div className={classes.chargeBreakdownCell} style={{ backgroundColor: color, fontWeight: 600 }}>
          {charge.name}
        </div>
        <div className={classes.chargeBreakdownCell} style={{ backgroundColor: color }}>
          <div className={classes.pricePerUnitRow}>
            <span className={classes.chargeBreakdownCurrency}>
              {charge?.currency}
            </span>
            <span>{charge.amount?.toFixed(2)}</span>
            <span className={classes.unitType}>
              / {chargeListUnitTypeMap[charge.unitType]}
            </span>
          </div>
        </div>
        <div
          className={classNames(classes.chargeBreakdownCell, classes.chargeBreakdownCellCenter)}
          style={{ backgroundColor: color }}
        >
          {charge?.unitCount}
        </div>
        <div
          className={classNames(classes.chargeBreakdownCell, classes.chargeBreakdownCellRight, classes.totalPriceWithMargin)}
          style={{ backgroundColor: color }}
        >
          <div className={classes.totalPriceRow}>
            <span className={classes.chargeBreakdownCurrency} style={{ lineHeight: '16px' }}>
              {charge?.currency}
            </span>
            <span className={classes.chargeAmount}>
              {charge.total?.toFixed(2)}
            </span>
          </div>
          {showMarginBreakdown && (
            <div className={classes.totalPriceMeta}>
              <span className={classes.chargeBreakdownCurrency}>
                {charge?.currency}
              </span>
              {data?.oceanFreight?.baseAmount?.toFixed(2)}
              <span
                className={classes.marginBadge}
                style={{
                  backgroundColor: totalMarkupAmount < 0 ? '#FFDFDF' : '#E3FFDB',
                }}
              >
                {renderAmount(data?.markup?.totalMarkupAmount, 'USD', true, true)} Margin
              </span>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  };

  const getSubtotalKey = (key): Charge => {
    switch (key) {
      case 'freightCharges':
        return data.totalFreight;
      case 'originCharges':
        return data.totalOriginCharge;
      case 'destinationCharges':
        return data.totalDestinationCharge;
      default:
        return data.totalFreight;
    }
  };

  const renderSubTotal = (key) => {
    const charge = getSubtotalKey(key);
    return (
      <Row>
        <Col span={5} />
        <Col span={19} className={classes.subtotal}>
          <Col span={17}>Subtotal:</Col>
          <Col span={7} style={getChargeDivStyle()}>
            <span className={classes.chargeBreakdownCurrency} style={{ lineHeight: '16px' }}>
              {charge?.currency}
            </span>
            <span className={classes.chargeAmount}>
              {formatNumberWithCommas(charge?.amount?.toFixed(2))}
            </span>
          </Col>
        </Col>
      </Row>
    );
  };

  const getChargeDivStyle = () => {
    return {
      display: 'flex',
      justifyContent: 'flex-end',
    };
  };

  const renderTotal = () => {
    return (
      <Row style={{ marginTop: '-24px' }}>
        <Col span={5} />
        <Col span={19} className={classNames(classes.subtotal, classes.total)}>
          <Col span={17}>Total:</Col>
          <Col span={7} style={getChargeDivStyle()}>
            <span className={classes.chargeBreakdownCurrency} style={{ lineHeight: '16px' }}>
              {total?.currency}
            </span>
            <span className={classes.chargeAmount} style={{ fontSize: '16px' }}>
              {formatNumberWithCommas(total?.amount?.toFixed(2))}
            </span>
          </Col>
        </Col>
      </Row>
    );
  };

  const renderChargesDetails = () => {
    return Object.keys(data.chargeBreakdown).map((key, index) => (
      <React.Fragment>
        {isValidArray(data.chargeBreakdown[key]) && (
          <div style={{ marginBottom: '24px' }}>
            {data.chargeBreakdown[key].map((charge, index) => {
              const rowColor = index % 2 === 0 ? '#F9F9F9' : '#FFFFFF';
              return (
                <div
                  className={classNames(classes.chargeBreakdownGrid, classes.chargeBreakdownRow)}
                  style={{ backgroundColor: rowColor }}
                >
                  <div className={classes.chargeBreakdownCell} style={{ backgroundColor: rowColor }}>
                    <span className={classes.title}>{index === 0 && renderChargeTitle(key)}</span>
                  </div>
                  {renderColumn(charge, index, rowColor)}
                </div>
              );
            })}
            {isLocalsPresent && renderSubTotal(key)}
          </div>
        )}
        {index === Object.keys(data.chargeBreakdown).length - 1 && renderTotal()}
      </React.Fragment>
    ));
  };

  const renderExchangeRates = (): React.ReactElement => {
    return (
      <React.Fragment>
        <Col span={6}></Col>
        <Col span={10}>
          {data.exchangeRate && Object.keys(data.exchangeRate).length !== 0 && (
            <React.Fragment>
              <Col span={6}>Exchange Rates:</Col>
              <Col span={18} className={classes.exchangeRate}>
                {Object.keys(data.exchangeRate)?.map((key) => {
                  const currencyType = key?.split('-');
                  return (
                    <span>
                      {`1 ${currencyType[0]} = ${data.exchangeRate[key]} ${currencyType[1]}`}
                    </span>
                  );
                })}
              </Col>
            </React.Fragment>
          )}
        </Col>
      </React.Fragment>
    );
  };

  const handleSubmit = (): void => {
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      setStateUtil({ isLoading: true });
      const searchRequest = {
        polId: searchFilters?.pol?.id,
        podId: searchFilters?.pod?.id,
        container: JSON.parse(searchFilters?.container)?.key,
        cargo: JSON.parse(searchFilters?.cargo)?.key,
        mode: searchFilters?.mode,
      };
      const body = {
        ...values,
        data,
        searchRequest: {
          ...searchRequest,
          view: activeKey,
          ...(activeKey === 'SELL' && {
            shipperOrganisationId:
              searchFilters?.shipperOrganisationId === 'nonLinkedShippers'
                ? undefined
                : searchFilters?.shipperOrganisationId,
            isNonLinkedShipperSelected:
              searchFilters?.shipperOrganisationId === 'nonLinkedShippers',
          }),
        },
      };
      const response = await discoverRatesReportIssue(body, activeKey);
      if (response.isSuccess) {
        getGAEventCategory(orgType, 'Report an Issue');
        setStateUtil({ isReportModalVisible: false, isReported: true });
        message.success('Thanks for your feedback. Our team will verify this rate');
      } else {
        getGAEventCategory(orgType, 'Report an Issue - Failed');
        message.error(response.errorMessage);
      }
      setStateUtil({ isLoading: false });
    });
  };

  const handleShareRateModal = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setShareModalVisible((prevState) => !prevState);
  };

  const openReportModal = (): React.ReactElement => {
    const modalTitle: React.ReactElement = (
      <span className={classes.modalTitle}>
        <Icon type="exclamation-circle" theme="filled" className={classes.reportIcon} /> Report
      </span>
    );
    const modalFooter: React.ReactElement = (
      <Button
        className={classes.reportSubmit}
        disabled={!form.getFieldValue('reason')}
        onClick={handleSubmit}
        loading={isLoading}
      >
        Submit
      </Button>
    );
    return (
      <Modal
        visible={isReportModalVisible}
        title={modalTitle}
        className={classes.reportModal}
        destroyOnClose
        onCancel={() => setStateUtil({ isReportModalVisible: false })}
        footer={modalFooter}
      >
        <span>Please write, why you want to report?</span>
        <Form.Item className={classes.error}>
          {form.getFieldDecorator('reason', {
            rules: [{ required: true, message: 'Reason is required' }],
          })(<Input.TextArea style={{ marginTop: '12px' }} rows={3} />)}
        </Form.Item>
      </Modal>
    );
  };

  const renderReportOption = (): React.ReactElement => {
    return (
      <Col span={8} style={{ display: 'flex', justifyContent: 'flex-end', fontWeight: 600 }}>
        {!isReported ? (
          <React.Fragment>
            <span
              className={classes.reportButton}
              onClick={() =>
                setStateUtil({
                  isReportModalVisible: true,
                })
              }
            >
              Report
            </span>
            &nbsp;for incomplete information.
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Icon
              type="exclamation-circle"
              theme="filled"
              style={{ fontSize: '16px', color: '#F6B728', marginRight: '4px' }}
            />
            Reported
          </React.Fragment>
        )}
      </Col>
    );
  };

  const renderFreeDays = (freeDays): React.ReactElement => {
    return (
      <div className={classes.otherDetails} style={{ fontWeight: 'normal' }}>
        Demurrage:{' '}
        <span style={{ fontWeight: 600 }}>&nbsp;{freeDays?.demurrageFreeDays || freeDays || '-'}</span>
        <br />
        Detention:{' '}
        <span style={{ fontWeight: 600 }}>&nbsp;{freeDays?.detentionFreeDays || freeDays || '-'}</span>
      </div>
    );
  };

  const renderOtherDetails = (): React.ReactElement => {
    const ETD = ((isModeTypeRoadDomestic || isModeTypeRPTL) && data?.etd && moment(data?.etd).format('DD MMM YYYY')) || '-';
    const SCHEDULE = ((isModeTypeRoadDomestic || isModeTypeRPTL) && data?.schedule?.length && (data?.schedule)?.map(day => weekDayMap[day]).join(', ')) || '-';
    const STOPS = ((isModeTypeRoadDomestic || isModeTypeRPTL) && data?.stops?.join(', ')) || '-';
    const BUSINESSTYPE_NAME = (isModeTypeRoadDomestic || isModeTypeRPTL) ? businessTypeList?.find(item => item?.key === data?.businessType)?.label || '-' : '-';
    
    return (
      <React.Fragment>
        <Row style={{ paddingTop: '24px' }}>
          <Col span={5} style={{ color: '#666666' }}>
            Internal Ref. No.
            <Tooltip title={data.internalReferenceNumber} placement="left">
              <div className={classes.otherDetails}>{data.internalReferenceNumber || '-'}</div>
            </Tooltip>
          </Col>
          {(isModeTypeRoadDomestic || isModeTypeRPTL) && <Col span={5} style={{ color: '#666666' }}>
            Business Type
            <Tooltip title={data.businessType} placement="left">
              <div className={classes.otherDetails}>{BUSINESSTYPE_NAME}</div>
            </Tooltip>
          </Col>}
          {(isModeTypeRoadDomestic || isModeTypeRPTL) && <Col span={5} style={{ color: '#666666' }}>
            ETD
            <Tooltip title={ETD} placement="left">
              <div className={classes.otherDetails}>{ETD}</div>
            </Tooltip>
          </Col>}
          {(isModeTypeRoadDomestic || isModeTypeRPTL) && <Col span={5} style={{ color: '#666666' }}>
              Schedule
              <Tooltip title={SCHEDULE} placement="left">
                <div className={classes.otherDetails}>{SCHEDULE}</div>
              </Tooltip>
            </Col>}
          {!(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && <Col span={5} style={{ color: '#666666' }}>
            Service Code
            <Tooltip title={data.serviceCode} placement="left">
              <div className={classes.otherDetails}>{data.serviceCode || '-'}</div>
            </Tooltip>
          </Col>}
          {!(isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) && <Col span={4} style={{ color: '#666666' }}>
            Transshipment Ports
            <div className={classes.otherDetails}>
              {(data.transshipments?.length &&
                data.transshipments.map((port) => <div>{port.name}</div>)) ||
                '-'}
            </div>
          </Col>}
          {(data.destinationFreeDays?.demurrageFreeDays ||
            data.destinationFreeDays?.detentionFreeDays) && (
              <Col span={4} style={{ color: '#666666' }}>
                Free Days (Destination)
                {renderFreeDays(data.destinationFreeDays)}
              </Col>
            )}
          {(data.originFreeDays?.demurrageFreeDays || data.originFreeDays?.detentionFreeDays) && (
            <Col span={4} style={{ color: '#666666' }}>
              Free Days (Origin)
              {renderFreeDays(data.originFreeDays)}
            </Col>
          )}
        </Row>
        {orgType === 'SHIPPER' && (
          <Row style={{ paddingTop: '24px' }}>
            <Col span={5} style={{ color: '#666666' }}>
              Stuffing Location
              <div className={classes.otherDetails} style={{textOverflow: 'unset', whiteSpace: 'unset'}}>
                {((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.origin?.displayAddress : data?.stuffingLocations?.[0]?.displayAddress) || '-'}
              </div>
            </Col>
            <Col span={5} style={{ color: '#666666' }}>
              De-stuffing Location
              <div className={classes.otherDetails} style={{textOverflow: 'unset', whiteSpace: 'unset'}}>
                {((isModeTypeRoadDomestic || isModeTypeTrailer || isModeTypeRPTL) ? data?.destination?.displayAddress : data?.destuffingLocations?.[0]?.displayAddress) || '-'}
                </div>
            </Col>
            {(isModeTypeRoadDomestic || isModeTypeRPTL) && <Col span={5} style={{ color: '#666666' }}>
              Stops
              <Tooltip title={STOPS} placement="left">
                <div className={classes.otherDetails}>{STOPS}</div>
              </Tooltip>
            </Col>}
          </Row>
        )}
        <Row style={{ marginTop: '24px' }}>
          <Col span={24}>
            Remarks
            <div style={{ marginTop: '8px' }}>
              {(isValidString(data.remarks) &&
                data.remarks.split('\n').map((item) => (
                  <div className={classes.remarks} style={{ margin: 0 }}>
                    {item}
                  </div>
                ))) ||
                '-'}
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  const renderTnC = (termsAndConditions): React.ReactElement => {
    const showIndex = termsAndConditions?.includes('\r\n');
    return (
      <Row style={{ marginTop: '45px' }}>
        <Col span={5} className={classes.title}>
          Terms and Conditions
        </Col>
        <Col span={19}>
          {nl2Br(termsAndConditions, '\r\n', showIndex, {
            marginBottom: '12px',
            display: 'flex',
            fontSize: '14px',
          })}
        </Col>
      </Row>
    );
  };

  const renderChargeBreakdown = (): React.ReactElement => {
    const carrierMap = arrayToObject(shippingLines, 'id');
    const termsAndConditions = carrierMap[data.carrier?.code]?.termsAndConditions;
    return (
      <div className={classes.chargesDiv}>
        {!isShareModule && (
          <div className={classNames(classes.rightAlign, classes.viewHideDetails)}>
            <span onClick={handleShareRateModal}>
              <Icon type="share-alt" /> Share Rates &nbsp;|&nbsp;
            </span>
            <span onClick={() => handleViewDetailsClick()}>Hide Details</span>
          </div>
        )}
        <div className={classNames(classes.chargeBreakdownGrid, classes.chargeBreakdownHeader)}>
          <div className={classes.chargeBreakdownCell}></div>
          <div className={classes.chargeBreakdownCell}>Charges</div>
          <div className={classes.chargeBreakdownCell}>Price Per Unit</div>
          <div className={classNames(classes.chargeBreakdownCell, classes.chargeBreakdownCellCenter)}>
            No. of Units
          </div>
          <div className={classNames(classes.chargeBreakdownCell, classes.chargeBreakdownCellRight)}>
            Total Price
          </div>
        </div>
        <div>{renderChargesDetails()}</div>
        <Row style={{ padding: '25px 0px 35px 0px', borderBottom: `1px solid ${tokens.colors.border}` }}>
          {renderExchangeRates()}
          {!isShareModule && renderReportOption()}
          {isValidString(termsAndConditions) && renderTnC(termsAndConditions)}
        </Row>
        {renderOtherDetails()}
      </div>
    );
  };

  const getRateTypeColor = (isFFBand = false): string => {
    if (isFFBand && data.shipperOrganisation) {
      return `rgb(251 210 210)`; 
    }
    if (isFFBand && ffListMap[data?.ffOrganisation?.id]?.linkingStatus === 'NON_LINKED') {
      return `#FDEBBB`;
    }
    switch (data.type) {
      case 'BUY':
        if (isFFBand) return '#CEF5EF';
        return `rgba(213, 244, 238, ${isFFBand ? '1' : '0.5'})`;
      default:
        if (isFFBand) return '#FDEBBB';
        return `rgba(255, 245, 219, 0.7)`;
    }
  };

  const handleNegotiateRates = async (): Promise<void> => {
    if (isDemoOrganisation()) {
      message.error(PERMISSON_ERROR_MESSAGE);
      return;
    }
    const { pol, pod, container, cargo, incoterm, movementType, mode, grossWeight, totalVolume,
      count = 1, length, breadth, height, dimensionUnit, totalVolumetricWeight } = searchFilters;
    const { originServices, destinationServices } = selectedFilters;
    const org = getOrgData();
    getAllDataSetFilter({ organisationList: [org] }, false);
    const cargoList = JSON.parse(cargo || '[]');
    const body = {
      mode,
      pol: pol?.code,
      pod: pod?.code,
      container: {
        ...(mode === InquiryModes.FCL && JSON.parse(container || '[]')?.key),
        count: mode !== FCL ? count : selectedFilters?.noOfContainers ?? 1,
        ...(length && {
          packageDimension: {
            height,
            breadth,
            length,
            unit: dimensionUnit,
          }
        }),
        ...(grossWeight && { weight: grossWeight }),
        ...(totalVolume && { volume: {...totalVolume, value: totalVolume.value / count}  }),
        ...(totalVolumetricWeight && { volumetricWeight: {...totalVolumetricWeight, value: totalVolumetricWeight.value / count}  })
      },
      cargoDetails: { cargo: cargoList?.key?.cargo, product: cargoList?.label?.product },
      incoterm, movementType,
      originServices, destinationServices,
    };
    setStateUtil({ fetchingCustomisedRates: true });
    const response = await fetchPreviousInquiries(body);
    if (response.isSuccess && isValidArray(response.data?.inquiries)) {
      setStateUtil({
        fetchingCustomisedRates: false,
        isInquiryConfirmationVisible: true,
        inquiryData: response.data.inquiries,
        searchParams: response.data.searchParams,
      });
    } else if (response.isSuccess) {
      handleNewInquiry(true);
      setStateUtil({ fetchingCustomisedRates: false });
    } else {
      message.error(response.errorMessage);
      setStateUtil({ fetchingCustomisedRates: false });
    }
  };

  const getOrgData = () => {
    const {
      ffOrganisation,
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
    } = data;
    return {
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
      orgName: ffOrganisation?.name,
      orgId: ffOrganisation?.id,
      linkingStatus: ffListMap[data?.ffOrganisation?.id]?.linkingStatus,
    };
  };

  const handleCheckboxChange = (val) => {
    const { organisationList } = selectedFilters;
    const clonedOrganitsations = isValidArray(organisationList) ? clone(organisationList) : [];
    let org: any[] = clonedOrganitsations;
    if (val.target.checked) {
      org.push(getOrgData());
    } else {
      org =
        clonedOrganitsations?.filter(
          (organisation) => organisation?.freightChargeId !== val.target.id
        ) || [];
    }
    getAllDataSetFilter({ organisationList: org }, false);
  };

  const renderCheckbox = () => {
    return (
      <Checkbox
        className={classes.selectSLCheckbox}
        id={data?.freightChargeId}
        checked={isRateCardSelected()}
        onChange={(e) => handleCheckboxChange(e)}
      />
    );
  };

  const isRateCardSelected = () => {
    return (
      isValidArray(selectedFilters?.organisationList) &&
      selectedFilters?.organisationList.some((org) => org.freightChargeId === data?.freightChargeId)
    );
  };

  const getBottomColor = () => {
    if (data.shipperOrganisation) {
      return `rgba(255, 226, 226, 0.7)`; 
    }
    if (ffListMap[data?.ffOrganisation?.id]?.linkingStatus === 'NON_LINKED') {
      return `rgba(255, 245, 219, 0.7)`;
    }
    return getRateTypeColor();
  };

  const handleCloseCreateBookingModal = (bookingNumber = undefined, bookingId = undefined) => {
    setStateUtil({
      bookingId,
      bookingNumber,
      isFFConnectionRequestVisible: false,
      isCreateInquiryModalVisible: false,
      protipVisible: bookingNumber ? true : false,
    });
  };

  const handleProtipClose = () => {
    setStateUtil({
      protipVisible: false,
    });
    history.push(bookingShipperRoute());
  };

  // const renderBookingTncModal = (): React.ReactElement => {
  //   return (
  //     <BookingTnCModal
  //       isVisible={isBookingTnCModalVisible}
  //       carrierCode={data.carrier?.code}
  //       onAccept={() => {
  //         setStateUtil({ isBookingTnCModalVisible: false });
  //         data.rank === 1 ? handleBookNow() : openInformReason();
  //       }}
  //       onDecline={() => setStateUtil({ isBookingTnCModalVisible: false })}
  //     />
  //   );
  // };

  const closeInformReason = () => {
    setStateUtil({
      viewInformReason: false,
    });
  };

  const openInformReason = () => {
    setStateUtil({
      viewInformReason: true,
    });
  };

  const setRemark = (val) => {
    setStateUtil({ remark: val });
  };

  const renderInformReasonModal = (): React.ReactElement => {
    const selectedBid = {
      id: data.id,
      shipperTotalWithoutTax: {
        amount: data.totalPrice?.amount,
        currency: data.totalPrice?.currency,
      },
    };
    const topRankBid = {
      id: topResult?.freightChargeId,
      shipperTotalWithoutTax: {
        amount: topResult?.totalPrice?.amount,
        currency: topResult?.totalPrice?.currency,
      },
    };
    return (
      <InformReason
        mode={searchFilters?.mode??FCL}
        type={'SHIPPER'}
        booking={true}
        topRankBid={topRankBid}
        selectedBid={selectedBid}
        visible={viewInformReason}
        handleCancel={closeInformReason}
        createBooking={handleBookNow}
        setRemark={setRemark}
        heading="Reason"
      />
    );
  };

  return (
    <div
      className={classes.mainDiv}
      style={{
        width: isShareModule
          ? '80%'
          : isLocalsOrMarginVisible() || isShipperWithCreateInquiryPermission()
            ? '96%'
            : '90%',
        border: isRateCardSelected() ? '1px solid #444444' : 'unset',
      }}
    >
      <Row className={classes.rateCard}>
        {orgType === 'SHIPPER' &&
          createInquiryPermission &&
          selectedFilters.isBulkNegotiationOn &&
          renderCheckbox()}
        {renderCarrierInfo()}
        {renderRouteInfo()}
        {renderChargeInfoDiv()}
      </Row>
      <Row style={{ padding: '0px 20px 5px' }}>
      {renderFreeDaysOnCard()}
      </Row>
      <Row
        
        style={{
          backgroundColor: getBottomColor(),
          border: '0 0 3px 3px',
        }}
      >
        {isChargeBreakdownVisible && renderChargeBreakdown()}
        {renderBottomCardDiv()}
      </Row>
      {isReportModalVisible && openReportModal()}
      {isInquiryConfirmationVisible && (
        <InquiryConfirmationModal
          isVisible={isInquiryConfirmationVisible}
          inquiryData={inquiryData}
          searchParams={searchParams}
          onOk={() => handleNewInquiry(true)}
          onConfirmationClose={() => {
            getAllDataSetFilter(
              {
                organisationList: undefined,
                isBulkNegotiationOn: false,
              },
              false
            );
            setStateUtil({
              isInquiryConfirmationVisible: false,
              inquiryData: [],
              searchParams: undefined,
            });
          }}
        />
      )}
      {isCreateInquiryModalVisible && (
        <CreateInquiryModal
          handleCancel={handleCloseCreateBookingModal}
          visible={isCreateInquiryModalVisible}
          data={inquiryDataResponse}
          fromDiscoverRates={true}
          freightChargeId={data.freightChargeId}
          bookingReason={remark}
          incoterm={incoterm}
          movementType={movementType}
          originServices={originServices}
          destinationServices={destinationServices}
          mode={mode} grossWeight={grossWeight} totalVolume={totalVolume}
        />
      )}
      {protipVisible && (
        <BookingSuccessProtip
          bookingId={bookingNumber}
          visible={protipVisible}
          handleClose={handleProtipClose}
          handleNotifyUsers={() => setStateUtil({ isAdditionalEmailsModalVisible: true, protipVisible: false })}
        />
      )}
      {isFFConnectionRequestVisible && (
        <FFConnectionRequestKYC
          isVisible={isFFConnectionRequestVisible}
          ffOrganisation={data.ffOrganisation}
          firstTime={!kycExists}
          kycData={kycData}
          createBooking={createBooking}
          isGeneratingBookingData={isGeneratingBookingData}
          onCancel={() => setStateUtil({ isFFConnectionRequestVisible: false })}
        />
      )}
      {/* {isBookingTnCModalVisible && renderBookingTncModal()} */}
      {viewInformReason && renderInformReasonModal()}
      {shareModalVisible && (
        <ShareRateModal
          freightChargeId={data?.freightChargeId}
          originChargeId={data?.originChargeId}
          destinationChargeId={data?.destinationChargeId}
          criteriaId={data?.criteriaId}
          criteriaRuleId={data?.criteriaRuleId}
          polName={data?.pol?.name}
          podName={data?.pod?.name}
          FFName={data?.ffOrganisation?.name ?? ffName}
          containerCount={selectedFilters?.noOfContainers ?? ''}
          cargo={{ ...JSON.parse(searchFilters?.cargo || '{}')?.label }}
          container={{ ...JSON.parse(searchFilters?.container || '{}')?.label }}
          freightValidity={moment(data?.validityEnd).format('DD MMM YYYY')}
          shipperId={searchFilters?.shipperOrganisationId}
          handleModal={handleShareRateModal}
          incoterm={incoterm}
          movementType={movementType}
          shipperTeamId={shipperTeamId}
          originServices={originServices}
          destinationServices={destinationServices}
          view={activeKey}
          uuid={uuid}
          mode={mode} 
          grossWeight={grossWeight} 
          totalVolume={totalVolume}
          totalVolumetricWeight={totalVolumetricWeight}
        />
      )}
      {isAdditionalEmailsModalVisible && (
        <AdditionalEmailsForBookingModal
          bookingId={bookingId}
          isVisible={isAdditionalEmailsModalVisible}
          handleCancel={() => {
            setStateUtil({ isAdditionalEmailsModalVisible: false, protipVisible: true });
          }}
          handleSuccess={() => {
            setStateUtil({ isAdditionalEmailsModalVisible: false });
            history.push(
              bookingShipperRoute(),
              { successMessage: 'Booking updates have been sent successfully to users!' },
            );
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ masterData, discoverRatesReducer, inquiryReducer, rateMasterReducer }, ownProps) => ({
  searchFilters: discoverRatesReducer.searchFilters,
  selectedFilters: discoverRatesReducer.selectedFilters,
  rateMasterData: discoverRatesReducer.ratesMasterData,
  buyRatesViewPermission: masterData.permissions.DISCOVER_BUY_RATES_VIEW,
  orgType: masterData.userData.type,
  userRole: masterData.userData.role,
  ffName: masterData.userData.ff_name,
  createInquiryPermission: masterData.permissions.INQUIRY_ALL_ACTIONS,
  shippingLines: masterData.globalShippingLines,
  uuid: discoverRatesReducer.uuid,
  showMarkupCriteria: masterData?.modules?.show_markup_criteria,
  businessTypeList: rateMasterReducer.ratesMasterData?.businessTypesList,
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ getAllDataSetFilter }, dispatch);

const ChargeListCardsStyled = withStyles(ChargeListCardsStyles)(Form.create()(ChargeListCards));
export default connect(mapStateToProps, mapDispatchToProps)(ChargeListCardsStyled);
